import * as yup from "yup";

export const fieldsConfig = {
  fullname: {
    label: "Nama Lengkap",
    type: "text",
    required: true,
    placeholder: 'Nama Lengkap',
    schema: yup.string().required("Nama Lengkap wajib diisi"),
  },
  email: {
    label: "Email",
    type: "email",
    required: true,
    placeholder: 'Email',
    schema: yup.string().email("Email tidak valid").required("Email wajib diisi"),
  },
  phone_number: {
    label: "No. HP",
    type: "text",
    required: true,
    placeholder: '62858xxxxx',
    schema: yup
      .string()
      .required("Nomor HP wajib diisi")
      .matches(/^62[0-9]{9,13}$/, "Nomor HP harus diawali dengan 62 dan panjang minimal 11 digit"),
  },
  password: {
    label: "Password",
    type: "password",
    required: true,
    placeholder: 'Password',
    schema: yup
      .string()
      .required("Password wajib diisi")
      .min(8, "Minimal 8 karakter")
      .matches(/[0-9]/, "Harus ada angka")
    // .matches(/[!@#$%^&*()]/, "Harus ada simbol spesial"),
  },
  password_confirmation: {
    label: "Konfirmasi Password",
    type: "password",
    required: true,
    placeholder: 'Konfirmasi Password',
    schema: yup
      .string()
      .oneOf([yup.ref("password")], "Konfirmasi password tidak cocok")
      .required("Konfirmasi password wajib diisi"),
  },
};

const schemaShape = Object.fromEntries(
  Object.entries(fieldsConfig).map(([key, val]) => [key, val.schema])
);

export const schema = yup.object().shape(schemaShape);

export const registerFields = Object.entries(fieldsConfig);

export type FormValues = yup.InferType<typeof schema>;
